import { Dialog } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';

import { TableHeader, SearchForm, SearchFormProps } from '@occc-app/design-system';
import { ScanDataMissingStoresDetailsFragment } from '@occc/graphql';
import { PaginationInfo } from '@occc-app/hooks/usePaginatedQuery';

import { ScanDataMissingStoresTable } from './scan-data-missing-stores-table.component';

import { useScanDataMissingStoresDetails } from '../../../hooks/use-scan-data-missing-stores-details.hook';

type ScanDataMissingStoresModalProps = {
  open: boolean;
  onClose: () => void;
};

export const ScanDataMissingStoresModal = ({ open, onClose }: ScanDataMissingStoresModalProps) => {
  const [search, setSearch] = useState('');
  const [paginationInfo, setPaginationInfo] = useState<PaginationInfo | undefined>();

  const { data, loading, error, paginationProps } = useScanDataMissingStoresDetails({
    search,
    paginationInfo,
    onPageChange: setPaginationInfo,
  });

  const handleSearchSubmit = useCallback<SearchFormProps['onSubmit']>(({ search }) => {
    setSearch(search || '');
    setPaginationInfo(undefined); // Reset pagination when searching
  }, []);

  const stores: ScanDataMissingStoresDetailsFragment[] | undefined = useMemo(() => {
    return data?.scanDataMissingStoresDetails?.edges?.map((edge) => edge.node);
  }, [data?.scanDataMissingStoresDetails?.edges]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <TableHeader
        title='Missing Stores'
        actions={<SearchForm onSubmit={handleSearchSubmit} initialValues={{ search }} />}
      />
      <ScanDataMissingStoresTable
        data={stores}
        loading={loading}
        error={error}
        paginationProps={paginationProps}
      />
    </Dialog>
  );
};
